import Meta from "vue-meta";

export default {
  install(Vue) {
    Vue.use(Meta, { keyName: "meta", refreshOnceOnNavigation: true });
  },
};
